module.exports = "<div class=\"image-hspinner\"><div ng-if=\"$ctrl.isShowWarinig\" class=\"text\"><h5>{{::'Подождите несколько минут. Всего может быть загружено до' | gettext}} {{$ctrl.limit}} {{::'строк...' | gettext}}</h5></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/hspinner.component.html
// module id = 963
// module chunks = 0